import { toast } from "react-toastify";
import { BtnBack } from "../../../../components/button/button-back";
import { BtnSubmit } from "../../../../components/button/button-submit/button-submit";
import CheckboxInput from "../../../../components/inputs/check";
import NumberInput from "../../../../components/inputs/number";
import TextInput from "../../../../components/inputs/text";
import MessageInput from "../../../../components/inputs/text-message";
import Loading from "../../../../components/loading";
import ModalMain from "../../../../components/modal";
import libForm from "../../../../util/libForm";
import { IndexHook } from "./hooks";
import InstagramPosts from "./posts";
import Notification from "../../../../components/toast";
import CreatableMultiSelectInput from "../../../../components/inputs/select-multi";
import { Alert } from "@mui/material";

const Form = ({
	isOpenModalRegister,
	ident,
	idTable,
	selectedData,
	setSelectData,
	// setLoading,
	fetchID,
	reloadData,
	insert,
}) => {
	const {
		//useForm
		register,
		handleSubmit,

		findTokenInstragram,
		dataInstagram,
		tokenInstagram,
		setTokenInstagram,
		selectedPostInstagram,
		postPreview,
		url_imagem,
		all_posts,

		loading,
		// setValue,
		control,
		// setFocus,

		//formState
		errors,
		isSubmitting,

		handleCloseModalRegister,
		handleOnSubmit,
	} = IndexHook({
		isOpenModalRegister,
		ident,
		idTable,
		selectedData,
		setSelectData,
		// setLoading,
		fetchID,
		reloadData,
		insert,
	});

	const handleOpenMainModal = (e) => {
		e.preventDefault();

		const token = findTokenInstragram();

		if (token) {
			setTokenInstagram(token);
			e.preventDefault();
			const event = new CustomEvent("modalInstagramPosts");
			window.dispatchEvent(event);
		} else
			Notification.showToast(
				"info",
				"Token não encontrado. Selecione uma conta Instagram para visualizar os posts."
			);
	};

	const handleCloseModalFilter = () => {
		const event = new CustomEvent("modalInstagramPosts");
		window.dispatchEvent(event);
	};

	return (
		<>
			{loading ? (
				<div className="flex h-full">
					<Loading mensagem="Carregando..." />
				</div>
			) : (
				<>
					<form
						className="form"
						onSubmit={handleSubmit(
							handleOnSubmit
							// handleOnError
						)}
					>
						<main>
							<div className="row">
								<div className="input-select-box d-flex flex-column col-8 col-sm-8 col-lg-4">
									<label htmlFor="id_instagram">Conta Instagram</label>
									<select
										{...register("id_instagram", {
											setValueAs: (value) => parseInt(value, 10),
										})}
										defaultValue=""
										onChange={(e) => {
											// handleCategoryChange(e);
											register("id_instagram").onChange(e);
										}}
										onKeyDown={(e) => libForm.EnterTab(e)}
									>
										<option value="" disabled>
											Selecione um tipo
										</option>
										{dataInstagram?.map((instagram) => (
											<option key={instagram.id_instagram} value={instagram.id_instagram}>
												{instagram.descricao}
											</option>
										))}
									</select>
									{errors.id_instagram && <p className="errors">{errors.id_instagram.message}</p>}
								</div>
								<div className="col-4 items-center flex">
									<CheckboxInput
										key="ativo"
										label="Ativo"
										id="ativo"
										register={register}
										errors={errors}
										className="col-12 col-sm-4 col-lg-3"
									/>
								</div>
							</div>
							<div className="row">
								<CheckboxInput
									label="Todos os posts"
									id="all_posts"
									register={register}
									errors={errors}
									onKeyDown={libForm.EnterTab}
									className="col-12"
								/>

								{all_posts ? (
									<div className="col-12 col-sm-6">
										<Alert severity="info">
											Com esta opção marcada, o retorno será enviado para todos os posts desta
											conta Instagram.
										</Alert>
									</div>
								) : (
									<div className="flex flex-col items-start justify-center mt-3 col-4">
										<div>
											<img src={url_imagem} alt="" className="object-cover shadow-lg  max-h-52" />
										</div>
										<button
											className="btn btn-sm btn-outline-primary mt-3 "
											onClick={handleOpenMainModal}
										>
											Escolher Post
										</button>
										{errors.cod_post && <p className="errors">{errors.cod_post.message}</p>}

										{postPreview && (
											<div className="bg-white shadow-md rounded-xl p-4">
												{postPreview.media_type === "IMAGE" && (
													<img
														src={postPreview.media_url}
														alt={postPreview.caption}
														className="w-full h-60 object-cover rounded-lg"
													/>
												)}
												{postPreview.media_type === "VIDEO" && (
													<video controls className="w-full h-60 object-cover rounded-lg">
														<source src={postPreview.media_url} type="video/mp4" />
													</video>
												)}
												<p className="mt-2 text-sm text-gray-700">
													{postPreview.caption || "Sem legenda"}
												</p>
											</div>
										)}
									</div>
								)}

								<div className="col-span-12">
									<CreatableMultiSelectInput
										name="triggers" // <- campo do Zod (string[])
										control={control}
										errors={errors}
										label="Gatilhos de envio"
										placeholder="Selecione ou digite…"
										className="col-12"
										initialOptions={[
											{ value: "eu quero", label: "Eu quero" },
											{ value: "quero", label: "Quero" },
											{ value: "interessado", label: "Interessado" },
											{ value: "me envie", label: "Me envie" },
											{ value: "me manda", label: "Me manda" },
											{ value: "mais informações", label: "Mais informações" },
										]}
									/>
								</div>
								<MessageInput
									label="Mensagem no Comentário (Obrigatório)"
									id="mensagem_comentario_1"
									placeholder=""
									register={register}
									errors={errors}
									onKeyDown={libForm.EnterTab}
									className="col-12 col-sm-4"
									toUpperCase={false}
								/>
								<MessageInput
									label="Mensagem no Comentário (Opcional)"
									id="mensagem_comentario_2"
									placeholder=""
									register={register}
									errors={errors}
									onKeyDown={libForm.EnterTab}
									className="col-12 col-sm-4"
									toUpperCase={false}
								/>
								<MessageInput
									label="Mensagem no Comentário (Opcional)"
									id="mensagem_comentario_3"
									placeholder=""
									register={register}
									errors={errors}
									onKeyDown={libForm.EnterTab}
									className="col-12 col-sm-4"
									toUpperCase={false}
								/>
								<Alert severity="info">
									Você pode cadastrar até três mensagens de resposta do comentário. Serão enviadas
									aleatoriamente.
								</Alert>

								<div className="p-4 ">
									<div className="w-full h-full p-4 shadow-md rounded-lg">
										<p className="text-sm font-semibold">Mensagem e Link DM</p>
										<MessageInput
											label="Mensagem na DM"
											id="mensagem_dm"
											placeholder=""
											register={register}
											errors={errors}
											onKeyDown={libForm.EnterTab}
											className="col-12 col-sm-6"
											toUpperCase={false}
										/>
										<TextInput
											label="Descrição do Link"
											id="titulo_link"
											placeholder=""
											register={register}
											errors={errors}
											onKeyDown={libForm.EnterTab}
											className="col-12"
											toUpperCase={false}
										/>
										<TextInput
											label="Link da mensagem/DM"
											id="link_mensagem_dm"
											placeholder=""
											register={register}
											errors={errors}
											onKeyDown={libForm.EnterTab}
											className="col-12"
											toUpperCase={false}
										/>
										{/* <MessageInput
											label="Mensagem na DM 2 (Opcional)"
											id="mensagem_dm_2"
											placeholder=""
											register={register}
											errors={errors}
											onKeyDown={libForm.EnterTab}
											className="col-12 col-sm-6"
											toUpperCase={false}
										/> */}
									</div>
								</div>
							</div>
							{/* {tokenInstagram && 
						<div>						
						<InstagramPosts token={tokenInstagram} />}
					
						</div> */}
						</main>

						<footer>
							<BtnBack onClick={(e) => handleCloseModalRegister()} isSubmitting={isSubmitting} />
							<BtnSubmit isSubmitting={isSubmitting} />
						</footer>
					</form>
					<ModalMain
						className="react-modal-content-base w-full max-w-[1050px] h-[90%] bg-white p-4 relative m-10"
						ident={"modalInstagramPosts"}
					>
						<div className="w-full h-full overflow-auto">
							<InstagramPosts
								token={tokenInstagram}
								handleCloseModalFilter={handleCloseModalFilter}
								selectedPostInstagram={selectedPostInstagram}
							/>
						</div>
					</ModalMain>
				</>
			)}
		</>
	);
};

export default Form;
